import landscapeSrc from "./landscape.svg";
import portraitSrc from "./portrait.svg";

const placeholders = {
  landscape: {
    src: landscapeSrc,
    srcWidth: 997,
    srcHeight: 665,
    alt: "",
  },
  portrait: {
    src: portraitSrc,
    srcWidth: 639,
    srcHeight: 852,
    alt: "",
  },
  square: {
    src: portraitSrc,
    srcWidth: 315,
    srcHeight: 315,
    alt: "",
  },
  wide: {
    src: landscapeSrc,
    srcWidth: 1000,
    srcHeight: 500,
    alt: "",
  },
};

export default placeholders;
